module.exports = __webpack_public_path__ + "static/img/tt-header-logo.1179967d.svg";